<script>

import { onMount } from "svelte";
import Table from './Views/Table.svelte';
import Map from './Views/Map.svelte';
import Images from './Views/Images.svelte';
import Graph from './Views/Graph.svelte';
let { error, results, query } = $props();

let currentView = $state('table');

onMount(() => {
    let valid = [
        'table',
        'map',
        'imagegrid',
        'graph',
    ];

    let view = query.match(/^#defaultView.*$/gm);
    if (view) {
        let data = view[0].substring(view[0].indexOf(':') + 1).trim();
        let match = data.match(/^[a-zA-Z]*/);
        if (match) {
            currentView = match[0].toLowerCase();
        }
    }

    if (valid.indexOf(currentView) === -1) {
        currentView = 'table';
    }
});

</script>

<style>

.summary {
    background-color: #E7E7E7;
    padding: 10px;
    display: flex;
    justify-content: end;
    align-items: center;
    margin-bottom: 1rem;
    gap: 10px;
}

</style>

{#if error}
    <div class="alert alert-danger text-center">
        {@html error}
    </div>
{:else}
    {#await results}
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    {:then res}
        {#if res.length == 0}
            <!-- Waiting -->
        {:else}
            {#if res.results.bindings.length != 0}
                <div class="summary">
                    <span class="count">
                        {#if res.results.bindings.length == 1}
                            1 result
                        {:else}
                            {res.results.bindings.length} results
                        {/if}
                    </span>
                </div>

                {#if currentView == 'table'}
                    <Table results={res} />
                {:else if currentView == 'map'}
                    <Map results={res} />
                {:else if currentView == 'imagegrid'}
                    <Images results={res} />
                {:else if currentView == 'graph'}
                    <Graph results={res} />
                {/if}
            {:else}
                <div class="alert alert-info text-center">
                    Empty result set.
                </div>
            {/if}
        {/if}
    {/await}
{/if}
